export const TICKETLOGTYPES = {
  CREATE: 0,
  ASSIGN: 1,
  TRANSFER: 2,
  CLOSE: 3
};

export const NOTIFICATIONTYPES = {
  GROUP_MENTION_CREATE: "group_mention_create",
  GROUP_MENTION_UPDATE: "group_mention_update",
};